import styled from "styled-components";
import { Modal } from "components/Modal";

export const SuccessModalContainer = styled(Modal)`
  .modal-dialog {
    max-width: 492px;
  }

  &.account-registration .modal-content {
    padding: 20px 40px;

    .logo-img .icon-timer {
      height: 64px;
      width: 64px;
    }

    .heading-space {
      .heading {
        font-size: 20px;
        font-weight: 500;
      }

      .description {
        font-size: 15px;
        font-weight: 400;
      }
    }
  }

  .modal-content {
    height: 100%;
    padding: 70px 40px 40px;
  }

  .modal-body {
    padding: 0;

    .btn-space {
      margin-top: 2em;
      text-align: center;

      .btn-ok {
        width: 80%;
        ${({ theme }) => theme.constants.BORDER_RADIUS_8};
        padding: 8px 0;
        height: 40px;
        width: 100%;
      }
    }
    .logo-img {
      display: flex;
      justify-content: center;
      .img {
        width: 135px;
        height: 135px;
      }
      .correct-icon {
        height: 110px;
        width: 110px;
      }
    }
    .heading-space {
      text-align: center;
      margin-top: 1em;
      .heading {
        font-style: normal;
        font-weight: 700;
        font-size: 23px;
        color: ${({ theme }) => theme.heading.color.secondary};
        text-align: center;
      }
      .description {
        font-size: 16px;
        font-weight: 700;
      }
    }
  }
`;
